export const API = 'https://api.openweathermap.org/data/2.5/weather?';
